import React from 'react';
import { IFileThumbnail } from '../../types';
import { PictureThumbnail } from './PictureThumbnail';
import { DocumentThumbnail } from './DocumentThumbnail';
import { use3dPreview } from '../../../../../utils/media-manager-sdk/hooks';
import { TranscodingStatus } from '../../../../../constants/TranscodingStatus';

export const ThreeDThumbnail: React.FC<IFileThumbnail> = (props) => {
  const [previewStatus, _] = use3dPreview(props.file);

  return previewStatus === TranscodingStatus.Failed ? (
    <DocumentThumbnail {...props} />
  ) : (
    <PictureThumbnail {...props} />
  );
};
